/**
 * Device Mappers
 * @description Utility functions for mapping between different device types
 */

import {
  Device,
  DeviceFormData,
  DeviceCreateRequest,
  DeviceUpdateRequest,
  // VehicleType,
} from '@/types/device.types';

/**
 * Maps DeviceFormData to DeviceCreateRequest
 */
export const toCreateRequest = (formData: DeviceFormData): DeviceCreateRequest => {
  return {
    serialNumber: formData.serialNumber,
    alias: formData.alias,
    description: formData.description,
    vehicle: {
      plate: formData.vehicle.plate || undefined,
      type: formData.vehicle.type || '', // Send empty string instead of undefined
      dimensions: formData.vehicle.dimensions,
    },
    versions: formData.versions,
    status: formData.status,
  };
};

/**
 * Maps DeviceFormData to DeviceUpdateRequest
 */
export const toUpdateRequest = (formData: DeviceFormData): DeviceUpdateRequest => {
  return {
    id: formData.id,
    serialNumber: formData.serialNumber,
    alias: formData.alias,
    description: formData.description,
    vehicle: {
      plate: formData.vehicle.plate || undefined,
      type: formData.vehicle.type || '', // Send empty string instead of undefined
      dimensions: formData.vehicle.dimensions,
    },
    versions: formData.versions,
    status: formData.status,
  };
};

/**
 * Maps Device (API response) to DeviceFormData
 */
export const toFormData = (device: Device): DeviceFormData => {
  return {
    id: device.id,
    serialNumber: device.serialNumber,
    alias: device.alias,
    description: device.description,
    vehicle: {
      plate: device.vehicle.plate || '',
      type: device.vehicle.type,
      dimensions: device.vehicle.dimensions,
    },
    versions: device.versions,
    status: device.status,
    lastConnection: device.lastConnection,
    lastOperation: device.lastOperation,
    nextExpectedSequence: device.nextExpectedSequence,
    metadata: device.metadata,
    createdAt: device.createdAt,
    updatedAt: device.updatedAt,
  };
};

/**
 * Device mappers object for easy import
 */
export const deviceMappers = {
  toCreateRequest,
  toUpdateRequest,
  toFormData,
};
